export default __webpack_public_path__ + "static/media/background.62055494.svg";